var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable import/prefer-default-export */
import { fetchUms } from "@dev-togetherprice/api.services";
const executeAsync = (ref) => __awaiter(void 0, void 0, void 0, function* () {
    const original = ref.executeAsync();
    if (!("MutationObserver" in window))
        return original;
    return new Promise((resolve, reject) => {
        var _a, _b;
        const frame = (_b = (_a = document.querySelector('iframe[src*="google.com/recaptcha/api2/bframe"]')) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.parentNode;
        if (!frame)
            return original.then(resolve).catch(reject);
        const observer = new MutationObserver(() => {
            if (Number(frame.style.opacity) === 0) {
                reject(new Error("User clicked outside"));
                observer.disconnect();
            }
        });
        observer.observe(frame, { attributes: true, attributeFilter: ["style"] });
        return original
            .then((result) => {
            observer.disconnect();
            resolve(result);
        })
            .catch((e) => {
            observer.disconnect();
            reject(e);
        });
    });
});
export const getRecaptcha = (ref) => __awaiter(void 0, void 0, void 0, function* () {
    const reCaptchaResult = { status: null, token: null };
    reCaptchaResult.token = yield executeAsync(ref);
    if (reCaptchaResult.token == null) {
        reCaptchaResult.status = "EXPIRED";
    }
    else {
        reCaptchaResult.status = "SUCCESS";
    }
    return reCaptchaResult;
});
export const isRecaptchaEnabled = () => fetchUms("/getConfigurations")
    .then((res) => +(res === null || res === void 0 ? void 0 : res["frontEnd.public.cardForm.recaptcha.enabled"]) > 0 &&
    !navigator.userAgent.includes("GabriPi"))
    .catch(() => false);
